function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
import { T } from "@supersig/validate";
import { buildConditionalByReturnValueType } from "./conditional";
import { buildLiteral } from "./literal";
import { buildReferential } from "./referential";
import { literalValueTypes } from "../literals";
export * from "./conditional";
export * from "./literal";
export * from "./referential";
const objectWithTypeValitor = T.object({
    type: T.string
});
const literalAndReferentialValueTypeMap = {
    literal: buildLiteral(literalValueTypes),
    referential: buildReferential(literalValueTypes)
};
export const literalAndReferentialValueTypes = T.union("type", literalAndReferentialValueTypeMap);
export const automatableWithoutConditional = T.union("type", literalAndReferentialValueTypeMap);
export const automatableValueTypes = T.union("type", _object_spread({
    conditional: buildConditionalByReturnValueType(T.union("type", literalAndReferentialValueTypeMap))
}, literalAndReferentialValueTypeMap));
const automatableValueTypesAndDefaultPropogationNoConditional = T.union("type", _object_spread_props(_object_spread({}, literalAndReferentialValueTypeMap), {
    default: T.object({
        type: T.literal("default")
    }),
    tombstone: T.object({
        type: T.literal("tombstone")
    })
}));
export const automatableValueTypesAndDefaultPropogation = T.union("type", _object_spread_props(_object_spread({
    conditional: buildConditionalByReturnValueType(automatableWithoutConditional)
}, literalAndReferentialValueTypeMap), {
    // Indicates that the value should be propogated from the default value
    default: T.object({
        type: T.literal("default")
    }),
    // Indicates that the value should actually be completely niled out, overrding
    // the default value to actually be undefined
    tombstone: T.object({
        type: T.literal("tombstone")
    })
}));
export const buildAutomatableValue = (value)=>{
    return T.union("type", {
        conditional: buildConditionalByReturnValueType(T.union("type", {
            literal: buildLiteral(value),
            referential: buildReferential(value)
        })),
        literal: buildLiteral(value),
        referential: buildReferential(value)
    });
};
// Builds something that could become an automatable value in the future
// even through it only allows literals right now
export const buildAutomatableValueLiteralOnly = (value)=>{
    return buildLiteral(value);
};
export * from "./Geometry2d";
export * from "./Box2d";
export * from "./Vec2d";
